import React, { useState } from 'react';
import rideService from 'src/services/rideService';

const AddDistrictPopup = ({ isOpen, onClose, id ,districtName}) => {


  const [district, setDistrict] = useState(districtName);
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  if (!isOpen) {
    return null;
  }

 
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setDistrict(inputValue);
  };

  
  const handleSubmit = () => {

    if (district == null || district == "") {
      setError("Something went wrong");
    } else {
      addOrUpdateDistrict();
   
    }

  };
  const addOrUpdateDistrict = () => {
    const districtDetails = {
      "district": district,
      "id":id
    
    }
    console.log(districtDetails);
    rideService.addDistrict(districtDetails).then((res) => {
      if (res.status == 200) {
        setIsSubmitted(true);
        window.location.reload();
      } else {
        setError("Something went wrong");
      }
    })
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md">
        <h2 className="text-lg font-semibold mb-4">Add District</h2>
        {/* Input field to update the value */}
        <input
          type="text"
          value={district}
          onChange={handleInputChange}
          className="w-full border p-2 mb-4"
        />

        {error && <p className="text-red-500">{error}</p>}
      
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            {id==null ? "ADD": "UPDATE"} District
          </button>
          <button
            onClick={onClose}
            className="ml-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
        </div>
        {isSubmitted ? (
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4">
            Submitted successfully!
          </div>
        ) : null}
      </div>
    </div>
    
  );
};

export default AddDistrictPopup;